// extracted by mini-css-extract-plugin
export default {"root":"FeatureFlagCard_root__Dcyjo","active":"FeatureFlagCard_active__0-gCz"};